import { makeStyles } from "@material-ui/core";

export const useStyles = makeStyles((theme) => ({
  error: {
    color: "red",
    fontSize: "12px !important",
  },
  inputError: {
    "& .MuiOutlinedInput-notchedOutline": {
      borderColor: "rgb(255 0 0 / 48%) !important",
    },
    "& .MuiOutlinedInput-root.Mui-focused": {
      "& .MuiOutlinedInput-notchedOutline": {
        borderColor: "rgb(255 0 0 / 48%) !important",
      },
    },
    "& .MuiOutlinedInput-root:hover": {
      "& .MuiOutlinedInput-notchedOutline": {
        borderColor: "rgb(255 0 0 / 48%) !important",
      },
    },
  },
  awardName: {
    [theme.breakpoints.between(1200, 1600)]: {
      flexWrap: "wrap",
    },
  },
  level: {
    [theme.breakpoints.between(1200, 1600)]: {
      flexWrap: "wrap",
    },
  },
}));
